import { Box, Typography } from '@mui/material';
import { tokens } from '../theme';

export default function Footer() {
  return (
    <Box component="footer" id="contact" sx={{ bgcolor: tokens.ink, pt: { xs: 6, md: 8.75 }, pb: 5, px: 3, borderTop: '1px solid rgba(238,236,227,0.08)' }}>
      <Box sx={{ maxWidth: 1080, mx: 'auto', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 5 }}>
        <Box>
          <Typography sx={{ fontFamily: tokens.display, fontStyle: 'italic', fontWeight: 600, fontSize: '1.6rem', color: tokens.paper }}>
            EWAS
            <Box component="span" sx={{ color: tokens.ember }}>.</Box>
          </Typography>
          <Typography sx={{ fontSize: '0.9rem', color: tokens.paperDim, mt: 1, maxWidth: 280, lineHeight: 1.6 }}>
            AI-powered early warning systems for climate resilience. Seeking research, commercialization, and
            incubation partners.
          </Typography>
        </Box>

        <Box sx={{ fontFamily: tokens.mono, fontSize: '0.82rem', color: tokens.paperDim, lineHeight: 2.1 }}>
          Dr. Murtaza Taj
          <br />
          <Box
            component="a"
            href="mailto:murtaza.taj@lums.edu.pk"
            sx={{ color: tokens.paper, textDecoration: 'none', borderBottom: '1px solid rgba(238,236,227,0.3)' }}
          >
            murtaza.taj@lums.edu.pk
          </Box>
          <br />
          +92 341 2077525
        </Box>
      </Box>

      <Box
        sx={{
          maxWidth: 1080,
          mx: 'auto',
          mt: 6.25,
          pt: 3,
          borderTop: '1px solid rgba(238,236,227,0.08)',
          fontFamily: tokens.mono,
          fontSize: '0.7rem',
          letterSpacing: '0.04em',
          color: tokens.paperFaint,
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 1,
        }}
      >
        <span>© 2026 EWAS — LUMS Computer Vision &amp; Graphics Lab</span>
        <span>www.ewas.io</span>
      </Box>
    </Box>
  );
}
